import { scrollToElementId } from '@/shared/utils';

export const scrollToSection = (id: string) => {
  if (scrollToElementId(id)) {
    return;
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
};
